import { type BasicConfig, fromBasicConfig } from "@hopper-b2b/portal";
import { ClientName } from "@hopper-b2b/types";
import { v4 as uuidv4 } from "uuid";
import { styleOverrides } from "../src/overrides/stylesOverrides";
import { icons } from "../src/theme/icons";
import { images } from "../src/theme/images";
import { muiBaseline, themeVariables } from "../src/theme/themeVariables";
import { branding } from "./branding";
import translations from "./translations";

const perkspotPortalConfig: BasicConfig = {
  /** Add your client name to the ClientName enum if needed **/
  clientName: ClientName.PERKSPOT,
  // Environments and Datadog configuration
  bootConfig: {},
  theme: {
    muiTheme: muiBaseline,
    variables: themeVariables,
    styleOverrides: styleOverrides,
    icons: icons,
    images: images,
  },
  featureFlags: {
    enablePricePrediction: true,
  },
  branding: branding,
  translations: translations,
};

export const environmentConfig = {
  version: import.meta.env.VITE_REACT_APP_VERSION ?? `local-${uuidv4()}`,
  spreedlyKey: import.meta.env.VITE_SPREEDLY_ENVIRONMENT_KEY ?? "",
};

export default fromBasicConfig(perkspotPortalConfig);
